export default __webpack_public_path__ + "static/gatsby_github_action1-7992c67888aaa24946e559b826a8aac2.png";